<template>
	<v-dialog
		v-model="fileMetaEditorDialog"
		fullscreen
		scrollable
		hide-overlay
		transition="dialog-bottom-transition"
		persistent
	>
		<v-card>
			<v-toolbar>
				<v-btn icon @click="closeFileMetaDialog">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title
					>{{ selectedFileMeta.stockistName }} -
					{{ selectedFileMeta._id }}</v-toolbar-title
				>
				<template v-slot:extension>
					<v-tabs v-model="model" slider-color="yellow" align-with-title grow>
						<v-tab v-for="i in tabItems" :key="i.tabId" :href="`#${i.tabId}`">{{
							i.name
						}}</v-tab>
					</v-tabs>
				</template>
			</v-toolbar>
			<v-tabs-items v-model="model">
				<v-tab-item v-for="i in tabItems" :key="i.tabId" :value="i.tabId">
					<v-card flat>
						<v-card-text>
							<component :dataProp="i.props" v-bind:is="i.component" />
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-card>
	</v-dialog>
</template>

<script>
import FileMetaEditor from './fileMetaEditor';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	components: {
		FileMetaEditor,
	},
	data() {
		return {
			tabItems: [
				{
					name: 'File Meta',
					tabId: 'tab-1',
					component: 'FileMetaEditor', // this component should show the detected meta for the file and it needs to be more like json viewer and not a editor
					props: {},
				},
			],
			model: 'tab-1',
		};
	},
	methods: {
		...mapMutations('fileMeta', ['closeFileMetaDialog']),
	},
	computed: {
		...mapGetters('fileMeta', ['fileMetaEditorDialog', 'selectedFileMeta']),
	},
};
</script>

<style lang="scss" scoped>
.v-card__text {
	padding: 0px;
}
</style>
